import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./noAuth.styl";
const template = require("./noAuth.vue");

@Component({
  template: template
})
export class NoAuthComponent extends Vue {

}

Vue.component("cmHome", NoAuthComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/noAuth/noAuth.ts